.select-mfa {
  display: flex;
  flex-direction: column;
  gap: 40px;
  height: fit-content;
  max-width: 450px;

  &--softphone {
    flex: 1;
    min-width: 100%;
    gap: 20px;
  }

  &__cards {
    margin: 30px;

    &--softphone {
      margin: 0;
    }
  }

  &__buttons {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  &__link-box {
    width: 100%;
    display: flex;

    justify-content: center;
  }
}
